/* Brooklyn Sells customizations: sidebar accordions and the Amazon outbound button. */

(function () {
  // Sidebar accordions. These are role="button" spans (not <button>) so Dawn's
  // MenuDrawer doesn't treat them as "close submenu" buttons.
  function toggleSection(toggle) {
    var panel = document.getElementById(toggle.getAttribute('data-bs-toggle'));
    if (!panel) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-bs-toggle]');
    if (!toggle) return;
    event.preventDefault();
    toggleSection(toggle);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var toggle = event.target.closest('[data-bs-toggle]');
    if (!toggle) return;
    event.preventDefault();
    toggleSection(toggle);
  });

  // Auto-open the sidebar after a delay (Header > Sidebar settings). Skipped when
  // the shopper is already busy: menu or cart open, typing, or a modal showing.
  (function autoOpenSidebar() {
    var drawer = document.querySelector('header-drawer[data-bs-auto-open]');
    if (!drawer) return;

    var delay = parseInt(drawer.getAttribute('data-bs-auto-open'), 10) || 5;
    var oncePerVisit = drawer.getAttribute('data-bs-auto-open-frequency') !== 'every_page';
    var onMobile = drawer.getAttribute('data-bs-auto-open-mobile') === 'true';
    var storageKey = 'bsSidebarAutoOpened';

    if (!onMobile && window.matchMedia('(max-width: 749px)').matches) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (oncePerVisit) {
      try {
        if (sessionStorage.getItem(storageKey)) return;
      } catch (error) {}
    }

    var interacted = false;
    var summary = drawer.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function () {
        interacted = true;
      });
    }

    setTimeout(function () {
      var details = drawer.querySelector('details');
      if (!summary || !details || interacted || details.hasAttribute('open')) return;
      if (document.querySelector('cart-drawer.active, details[open] > .modal__content, .quick-add-modal[open], modal-dialog[open]')) return;
      var active = document.activeElement;
      if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return;

      summary.click();
      // Dawn moves focus into the drawer; with no prior click or key press the
      // browser then draws a square focus ring around the close button (and
      // later the menu button). The shopper didn't ask for this, so don't
      // move their focus.
      if (document.activeElement === summary) summary.blur();
      if (oncePerVisit) {
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (error) {}
      }
    }, delay * 1000);
  })();

  // Amazon outbound button on product pages. Spreadr renders #SpreadrLink and
  // opens Amazon (with affiliate tags) on click; we relabel it, copy the deal
  // code first when there is one, and tell shoppers they are leaving the site.
  if (!document.body.classList.contains('bs-amazon-product')) return;

  var dealCode = (document.body.getAttribute('data-bs-deal-code') || '').trim();
  var associateTag = (document.body.getAttribute('data-bs-amazon-tag') || '').trim();

  // Spreadr opens window.spreadrRedirectURL; add the Associates tracking ID when
  // it's an amazon.com link that doesn't carry one yet.
  function tagSpreadrUrl() {
    if (!associateTag || typeof window.spreadrRedirectURL !== 'string') return;
    try {
      var url = new URL(window.spreadrRedirectURL);
      if (!/(^|\.)amazon\.com$/.test(url.hostname) || url.searchParams.has('tag')) return;
      url.searchParams.set('tag', associateTag);
      window.spreadrRedirectURL = url.toString();
    } catch (error) {}
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'absolute';
    field.style.left = '-9999px';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(field);
    }
    return Promise.resolve();
  }

  function buildExtras() {
    var wrapper = document.createElement('div');
    wrapper.className = 'bs-amazon-cta-extra';

    if (dealCode) {
      var code = document.createElement('div');
      code.className = 'bs-deal-code';

      var text = document.createElement('div');
      var label = document.createElement('div');
      label.className = 'bs-deal-code__label';
      label.textContent = 'Deal code';
      var value = document.createElement('div');
      value.className = 'bs-deal-code__value';
      value.textContent = dealCode;
      text.appendChild(label);
      text.appendChild(value);

      var status = document.createElement('span');
      status.className = 'bs-deal-code__status';
      status.setAttribute('aria-live', 'polite');

      code.appendChild(text);
      code.appendChild(status);
      wrapper.appendChild(code);
    }

    var note = document.createElement('p');
    note.className = 'bs-leaving-note';
    note.innerHTML =
      '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M9 2h5v5M14 2 7.5 8.5M12 9.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span>You’ll leave Brooklyn Sells and finish your purchase on Amazon.com' +
      (dealCode ? ' — paste the code at checkout' : '') +
      '. As an Amazon Associate we earn from qualifying purchases.</span>';
    wrapper.appendChild(note);

    var instagram = document.body.getAttribute('data-bs-instagram');
    if (instagram) {
      var handle = instagram.split('?')[0].split('instagram.com/').pop().replace(/\//g, '');
      var igLine = document.createElement('p');
      igLine.className = 'bs-ig-line';
      igLine.appendChild(document.createTextNode('More daily deals on Instagram: '));
      var igLink = document.createElement('a');
      igLink.href = instagram;
      igLink.target = '_blank';
      igLink.rel = 'noopener';
      igLink.textContent = '@' + handle;
      igLine.appendChild(igLink);
      wrapper.appendChild(igLine);
    }

    return wrapper;
  }

  function enhance(button) {
    if (button.dataset.bsEnhanced) return;
    button.dataset.bsEnhanced = 'true';

    var label = button.querySelector('#SpreadrLinkText');
    if (label) label.textContent = dealCode ? 'Copy Code & View on Amazon' : 'View on Amazon';
    button.setAttribute(
      'aria-label',
      (dealCode ? 'Copy deal code and view' : 'View') + ' this product on Amazon (opens in a new tab)'
    );

    var extras = buildExtras();
    button.insertAdjacentElement('afterend', extras);

    // Capture phase: runs before Spreadr's onclick opens Amazon.
    button.addEventListener('click', tagSpreadrUrl, true);

    if (dealCode) {
      // Capture phase so the code is on the clipboard before Spreadr opens Amazon.
      button.addEventListener(
        'click',
        function () {
          var status = extras.querySelector('.bs-deal-code__status');
          copyText(dealCode).then(
            function () {
              if (status) status.textContent = 'Copied ✓';
            },
            function () {
              if (status) status.textContent = 'Copy failed — select the code';
            }
          );
        },
        true
      );
    }
  }

  function waitForButton(attempt) {
    var button = document.getElementById('SpreadrLink');
    if (button) return enhance(button);
    if (attempt < 50) setTimeout(waitForButton, 100, attempt + 1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForButton(0);
    });
  } else {
    waitForButton(0);
  }
})();

/* SHOP 50 / SHOP 100 / SHOP ALL: page-size buttons and the "all" loader. */

(function () {
  // Keep the shopper's current filters and sort order when switching page size.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bs-view]');
    if (!button || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.set('view', button.getAttribute('data-bs-view'));
    window.location.href = window.location.pathname + '?' + params.toString();
  });

  // Shopify caps a page at 250 products, so in "all" mode fetch the remaining
  // pages one after another and append their cards to the grid.
  if (customElements.get('bs-load-all')) return;

  class BsLoadAll extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('.bs-load-all__status');
      this.loadFrom(this.dataset.next);
    }

    loadFrom(url) {
      var self = this;
      var grid = document.getElementById('product-grid');
      if (!url || !grid || !this.isConnected) return this.finish();

      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(this.dataset.section);
      fetch(fetchUrl)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          if (!self.isConnected) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('#product-grid > li').forEach(function (item) {
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            grid.appendChild(document.importNode(item, true));
          });
          if (self.status) {
            self.status.textContent =
              'Loading all ' + self.dataset.total + ' products… (' + grid.children.length + ' shown)';
          }
          var next = doc.querySelector('bs-load-all');
          self.loadFrom(next ? next.dataset.next : null);
        })
        .catch(function () {
          if (self.status) self.status.textContent = 'Some products could not be loaded. Please refresh the page.';
        });
    }

    finish() {
      var grid = document.getElementById('product-grid');
      if (this.status && grid) this.status.textContent = 'Showing all ' + grid.children.length + ' products';
    }
  }

  customElements.define('bs-load-all', BsLoadAll);
})();

/* Sidebar "Just added" slider: the newest products, auto-advancing. */

(function () {
  var sliders = document.querySelectorAll('[data-bs-latest]');
  if (!sliders.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency });

  function sized(src, width) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function slideHtml(product) {
    var image = product.images && product.images[0];
    var price = product.variants && product.variants[0] ? parseFloat(product.variants[0].price) : null;
    var li = document.createElement('li');
    li.className = 'bs-latest__slide';
    var a = document.createElement('a');
    a.className = 'bs-latest__link';
    a.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + product.handle;
    if (image) {
      var img = document.createElement('img');
      img.className = 'bs-latest__img';
      img.src = sized(image.src, 300);
      img.alt = '';
      img.loading = 'lazy';
      img.width = 150;
      img.height = 150;
      a.appendChild(img);
    }
    var title = document.createElement('span');
    title.className = 'bs-latest__title';
    title.textContent = product.title;
    a.appendChild(title);
    if (price !== null && !isNaN(price)) {
      var priceEl = document.createElement('span');
      priceEl.className = 'bs-latest__price';
      priceEl.textContent = money.format(price);
      a.appendChild(priceEl);
    }
    li.appendChild(a);
    return li;
  }

  function start(slider) {
    var track = slider.querySelector('.bs-latest__track');
    var paused = false;
    var index = 0;

    slider.addEventListener('pointerenter', function () { paused = true; });
    slider.addEventListener('pointerleave', function () { paused = false; });
    slider.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    slider.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 4000); });
    slider.addEventListener('focusin', function () { paused = true; });
    slider.addEventListener('focusout', function () { paused = false; });

    if (reduceMotion) return;

    setInterval(function () {
      if (paused || document.hidden || !track.offsetParent) return;
      var slides = track.children;
      if (slides.length < 2) return;
      var slideWidth = slides[0].getBoundingClientRect().width;
      var perView = Math.max(1, Math.round(track.clientWidth / slideWidth));
      var last = Math.max(0, slides.length - perView);
      // Pick up from wherever the shopper last swiped to.
      index = Math.round(track.scrollLeft / (slides[1].offsetLeft - slides[0].offsetLeft));
      index = index >= last ? 0 : index + 1;
      track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }, 3000);
  }

  function load(slider) {
    var limit = parseInt(slider.getAttribute('data-limit'), 10) || 12;
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    fetch(root + 'products.json?limit=' + limit)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (data) {
        var track = slider.querySelector('.bs-latest__track');
        (data.products || []).forEach(function (product) {
          track.appendChild(slideHtml(product));
        });
        if (track.children.length) {
          slider.classList.add('is-ready');
          start(slider);
        }
      })
      .catch(function () {});
  }

  // Load once the page has settled so the slider never delays the storefront.
  function loadAll() {
    setTimeout(function () {
      sliders.forEach(load);
    }, 1500);
  }
  if (document.readyState === 'complete') loadAll();
  else window.addEventListener('load', loadAll);
})();
